import type { JSX } from 'react'

import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'

import classes from './style.module.css'

export function Title(): JSX.Element {
  return <AppTitle>No Content</AppTitle>
}

NoContentPage.displayName = 'NoContentPage'
export function NoContentPage(): JSX.Element {
  return (
    <ui.PageWrapper className={classes.noContentPage}>
      {/* No content view "NoContentBlock" is shown on that page, enabled by ".page-wrapper:empty" */}
      <></>
    </ui.PageWrapper>
  )
}
